//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Vyp.WebControls.StartPage.ts                         </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2023                            </Copyright>
//    <Created>     2023-01-02                                                  </Created>
//  </FileHeader>

namespace Gordic.Vyp.Others
{
    @Decorators.gcontent
    export class StartPage extends GContentBase<Wfl.AC.WflBaseAC>
    {
        scorecardItems: any[] = [];
        divSection1: JQuery<HTMLElement> | undefined;
        divSection2: JQuery<HTMLElement> | undefined;

        onContentReady()
        {
            //this.SetData();
            debugger;
            var div = $("<div>").css("display", "flex").css("align-items", "stretch").css("align-content", "stretch").css("flex-wrap", "wrap").appendTo(this.element);
            div.width("100%");
            this.divSection1 = $("<div>").width("300px").css("min-width", "300px").css("max-width", "320px").css("flex-grow", "1").appendTo(div);
            this.divSection2 = $("<div>").css("flex-grow", "3").appendTo(div);
            this.GenerateKpi();
            Gordic.Wfl.AC.WflBaseAC.InitControl(this);
            Gordic.Wfl.AC.WflBaseAC.CompleteMenu(this);
        }

        GenerateKpi()
        {
            var that = this;            
        };
     
        ShowCounts()
        {
        };

        LoadData()
        {
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
        }

        ReloadData() {
            this.LoadData();
        }
    }
};
